import { createBrowserRouter } from 'react-router-dom'
import { Home, DSersTrackingTemplete, Tracking, PublicTracking } from '../page'

const { hostname } = window.location

const DFAULT_TRACKING_PATH = '/proxy_tracking/'
const SHOPIFY_PATH = window.location.pathname

const ROUTER_MAP: Record<string, any> = {
	'www.dsers.com': DFAULT_TRACKING_PATH,
	'dev.dsers.com': DFAULT_TRACKING_PATH,
	localhost: '/'
}

const baseNameConfig = {
	basename: Object.keys(ROUTER_MAP).includes(hostname) ? ROUTER_MAP[hostname] : SHOPIFY_PATH
}

const routerConfig = [
	{
		path: '/',
		element: <Tracking />
	},
	{
		path: 'tracking_template',
		element: <PublicTracking />
	},
	{
		path: 'dsers_template',
		element: <DSersTrackingTemplete />
	}
]

export const router = createBrowserRouter(routerConfig, baseNameConfig)
